/** True when `endDate` falls on the same local calendar day as `now` (inclusive until 23:59:59). */
export function isEncounterSameLocalDay(
  endDate: Date | string | null | undefined,
  now: Date = new Date(),
): boolean {
  if (endDate == null || endDate === '') {
    return false;
  }

  const ended = new Date(endDate);
  if (Number.isNaN(ended.getTime())) {
    return false;
  }

  return (
    ended.getFullYear() === now.getFullYear() &&
    ended.getMonth() === now.getMonth() &&
    ended.getDate() === now.getDate()
  );
}
